/**
 * RelatedSlider custom element - used by main-product (recommendations/complementary)
 * and collection-products section. Use data-skip-fetch="true" when content is already in DOM.
 */
class RelatedSlider extends HTMLElement {
  constructor() {
    super();

    const initSlider = (el) => {
      const slider = el.querySelector('.related-slider__list');
      const prevBtn = el.querySelector('.related-slider__button-prev');
      const nextBtn = el.querySelector('.related-slider__button-next');
      const twoColumns = el.querySelector('.swiper-wrapper-2-mobile');
      const slides1200Attr = el.getAttribute('data-slides-1200');
      const slides1200 = slides1200Attr ? parseInt(slides1200Attr, 10) : 4;
      if (slider && prevBtn && nextBtn && !slider.swiper) {
        if (twoColumns) {
          new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: { nextEl: nextBtn, prevEl: prevBtn },
            breakpoints: { 750: { slidesPerView: 2 }, 1200: { slidesPerView: slides1200 } },
          });
        } else {
          new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: { nextEl: nextBtn, prevEl: prevBtn },
            breakpoints: { 750: { slidesPerView: 2 }, 1200: { slidesPerView: slides1200 } },
          });
        }
      }
    };

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      if (this.dataset.skipFetch === 'true') {
        initSlider(this);
        return;
      }

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const relatedSlider = html.querySelector(
            `related-slider[data-id="${this.getAttribute('data-id')}"]`
          );
          if (relatedSlider && relatedSlider.innerHTML.trim().length) {
            this.innerHTML = relatedSlider.innerHTML;
          }
          initSlider(this);

          /* Color swatches */
          const generateSrcset = (image, widths = []) => {
            const imageUrl = new URL(image['src']);
            return widths
              .filter((width) => width <= image['width'])
              .map((width) => {
                imageUrl.searchParams.set('width', width.toString());
                return `${imageUrl.href} ${width}w`;
              })
              .join(', ');
          };

          const createImageElement = (image, classes, sizes, productTitle) => {
            const previewImage = image['preview_image'];
            const newImage = new Image(previewImage['width'], previewImage['height']);
            newImage.className = classes;
            newImage.alt = image['alt'] || productTitle;
            newImage.sizes = sizes;
            newImage.src = previewImage['src'];
            newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
            newImage.loading = 'lazy';
            return newImage;
          };

          const checkSwatches = () => {
            this.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
              wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                input.addEventListener('click', (event) => {
                  const primaryImage = wrapper.querySelector('.media--first');
                  const secondaryImage = wrapper.querySelector('.media--second');
                  const handleProduct = wrapper.dataset.product;

                  if (event.currentTarget.checked && primaryImage) {
                    wrapper
                      .querySelector('.js-color-swatches-link')
                      .setAttribute('href', event.currentTarget.dataset.variantLink);
                    if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                      wrapper
                        .querySelector('.card__add-to-cart button[name="add"]')
                        .setAttribute('aria-disabled', false);
                      wrapper
                        .querySelector('.card__add-to-cart button[name="add"] > span')
                        .classList.remove('hidden');
                      wrapper
                        .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                        .classList.add('hidden');
                      wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                        event.currentTarget.dataset.variantId;
                    }

                    const currentColor = event.currentTarget.value;

                    if (typeof jQuery !== 'undefined') {
                      jQuery.getJSON(
                        window.Shopify.routes.root + `products/${handleProduct}.js`,
                        function (product) {
                          const variant = product.variants.filter(
                            (item) =>
                              item.featured_media != null &&
                              item.options.includes(currentColor)
                          )[0];

                          if (variant) {
                            const newPrimaryImage = createImageElement(
                              variant['featured_media'],
                              primaryImage.className,
                              primaryImage.sizes,
                              product.title
                            );

                            if (newPrimaryImage.src !== primaryImage.src) {
                              let flag = false;
                              if (secondaryImage) {
                                const secondaryImagePathname = new URL(
                                  secondaryImage.src
                                ).pathname;
                                const newPrimaryImagePathname = new URL(
                                  newPrimaryImage.src
                                ).pathname;

                                if (
                                  secondaryImagePathname == newPrimaryImagePathname
                                ) {
                                  primaryImage.remove();
                                  secondaryImage.classList.remove('media--second');
                                  secondaryImage.classList.add('media--first');
                                  flag = true;
                                }
                              }
                              if (flag == false) {
                                primaryImage.animate(
                                  { opacity: [1, 0] },
                                  {
                                    duration: 200,
                                    easing: 'ease-in',
                                    fill: 'forwards',
                                  }
                                ).finished;
                                setTimeout(function () {
                                  primaryImage.replaceWith(newPrimaryImage);
                                  newPrimaryImage.animate(
                                    { opacity: [0, 1] },
                                    { duration: 200, easing: 'ease-in' }
                                  );
                                  if (secondaryImage) {
                                    secondaryImage.remove();
                                  }
                                }, 200);
                              }
                            }
                          }
                        }
                      );
                    }
                  }
                });
              });
            });
          };

          checkSwatches();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }
}

if (!customElements.get('related-slider')) {
  customElements.define('related-slider', RelatedSlider);
}
